import { render } from "./PageGroupRow.vue?vue&type=template&id=6b7ba3cf&scoped=true"
import script from "./PageGroupRow.vue?vue&type=script&lang=js"
export * from "./PageGroupRow.vue?vue&type=script&lang=js"

import "./PageGroupRow.vue?vue&type=style&index=0&id=6b7ba3cf&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7ba3cf"]])

export default __exports__